import styled from 'styled-components';
import { colors, fontFamilySize, px } from '../../../../../../contrib/ui';

export const PlayerMetaDataStyled = styled.div`
  padding: ${px(30)} ${px(20)};
  margin-bottom: ${px(150)};
  border-top: ${px(1)} solid var(--greydd);

  .grid-item {
    &.no-tee {
      p {
        ${fontFamilySize('Light', 14)};
        color: ${colors.grey4a};
      }
    }
  }
`;
